import tagTester from './_tagTester.js';

export default tagTester('String');



//////////////////
// WEBPACK FOOTER
// ./~/backbone/~/underscore/modules/isString.js
// module id = 185
// module chunks = 8